const PRESERVE_KEYS = new Set(["priceList", "mBatch", "alternateUom", "productAddons", "customAttributes", "uomData"]);

export function trimProductData(product) {
  const trimmed = {};
  for (const key of Object.keys(product)) {
    const val = product[key];
    if (PRESERVE_KEYS.has(key)) {
      trimmed[key] = val;
      continue;
    }
    if (val === null || val === undefined || val === "" || val === "null") continue;
    if (Array.isArray(val) && val.length === 0) continue;
    trimmed[key] = val;
  }
  return trimmed;
}

export function trimProductsBatch(products) {
  return products.map(trimProductData);
}
